import axios from 'axios';

export const getTestClock = async (testClockId: string, orgId: string) => {
  const { data } = await axios.get(
    `https://staging.airwallex.com/proxy-service/ts-external-billing-gateway.billing.gcp-sg.staging.awx.im/internal-api/v1/test_clocks/${testClockId}`,
    {
      headers: {
        'x-jwt-org-id': orgId,
      },
    }
  );
  return data;
};
